import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import React, {useEffect, useImperativeHandle, useState} from "react";
import {
  columnsBpTableMenu,
  columnsIcdTableMenu,
  listOptionMat,
} from "./ConcludeIcd.config";
import "./ConcludeIcd.scss";

import {
  medicineStoreService,
  medicalExaminationService,
  examinationService,
} from "api";

import {useAppDispatch, useAppSelector} from "redux/hooks";
import {RootState} from "redux/store";

import TableInputAdd from "./TableInputAdd/TableInputAdd";
import Notification from "components/common/notification/notification";
import TableInputAdd2 from "./TableInputAdd2/TableInputAdd";
import {convertIosStringToDate} from "helper/common";
import {setDataPhieu, setRequiredTaiKham} from "redux/reducer/examination";
import Icon from "assets/icons";
import ModalPrintTP from "./ModalPrintTP/ModalPrintTP";
import ModalPrintXNM from "./ModalPrintXNM/ModalPrintXNM";
import ModalPrintTTT from "./ModalPrintTTT/ModalPrintTTT";
import {tabKeys} from "types/enums";

const ConcludeIcd = React.forwardRef((props: any, ref) => {
  const {concludeForm} = props;
  const [icdSource, setIcdSource] = useState<any>([{}]);
  const [bpSource, setBpSource] = useState<any>([{}]);
  const activeExamTab = useAppSelector(
    state => state.examination.activeExamTab
  );
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const theoDoi = Form.useWatch("theoDoi", form);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaiThuoc, setLoaiThuoc] = useState<any>([]);
  const [icdList, setIcdList] = useState<any>([]);
  const listIcd = JSON.parse(localStorage.getItem("listIcd") || null);
  const [timeCallIcd, setTimeCallIcd] = useState<any>(1);
  const dataPhieu = useAppSelector(state => state.examination.dataPhieu);
  useImperativeHandle(ref, () => ({
    handleSave: handleSaveAll,
  }));
  const handleSaveAll = async () => {
    await handleSave();
  };
  useEffect(() => {
    if (listIcd?.length > 0) {
      setIcdList(listIcd);
    }
  }, []);
  useEffect(() => {
    dispatch(setRequiredTaiKham(theoDoi));
  }, [theoDoi]);
  useEffect(() => {
    setTimeCallIcd(1);
  }, [activeExamTab]);
  useEffect(() => {
    if (timeCallIcd <= 3 && icdList?.length > 0 == false) {
      getIcdList();
    }
    if (timeCallIcd == 4 && icdList?.length > 0 == false) {
    }
  }, [timeCallIcd, icdList]);
  const getIcdList = async () => {
    try {
      setLoading(true);
      const response = await medicalExaminationService.getIcdList();
      setTimeCallIcd(timeCallIcd + 1);
      // const uniqueList = response.data.filter((item, index, self) =>
      //   index === self.findIndex((t) => t.maIcd === item.maIcd || t.tenIcd === item.tenIcd)
      // )
      localStorage.setItem("listIcd", JSON.stringify(response?.data || null));
      setIcdList(response.data);
    } catch (error) {
      setLoading(false);
      setTimeCallIcd(timeCallIcd + 1);
    }
  };
  const {idPKNT} = useAppSelector((state: RootState) => state.examination);
  const {currentIdPKNT} = useAppSelector(
    (state: RootState) => state.examination
  );
  const fetchLoaiThuoc = async params => {
    try {
      setLoading(true);
      let response = await medicineStoreService.getListLoaiThuoc(params);
      setLoaiThuoc(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  // const onConcludeSave = e => {};
  const onIcdChange = () => {};
  // const onSelectRow = () => {};
  const columnsIcd = columnsIcdTableMenu.map(col => {
    if (col.dataIndex === "maIcd") {
      return {
        ...col,
        options: [
          ...icdList.map((it, idx) => ({
            key: it.id,
            value: it.maIcd,
            // label: it.maIcd,
          })),
        ],
        onChange: onIcdChange,
      };
    } else if (col.dataIndex === "mat") {
      return {
        ...col,
        options: listOptionMat,
      };
    } else if (col.dataIndex === "tenIcd") {
      return {
        ...col,
        options: [
          ...icdList.map(it => ({
            key: it.id,
            value: it.tenIcd,
            // label: it.tenIcd,
          })),
        ],
      };
    } else return col;
  });
  const columnsBp = columnsBpTableMenu.map(col => {
    if (col.dataIndex === "maIcd") {
      return {
        ...col,
        options: [
          ...icdList.map((it, idx) => ({
            key: it.id,
            value: it.maIcd,
            // label: it.maIcd,
          })),
        ],
        onChange: onIcdChange,
      };
    } else if (col.dataIndex === "tenIcd") {
      return {
        ...col,
        options: [
          ...icdList.map(it => ({
            key: it.id,
            value: it.tenIcd,
            // label: it.tenIcd,
          })),
        ],
      };
    } else return col;
  });
  const [ketLuan, setKetLuan] = useState<any>(null);
  const fetchKetLuanByIdPKNT = async () => {
    try {
      setLoading(true);
      let response = await medicalExaminationService.getKetLuanByIdPKNT({
        idPhieuKhamNgoaiTru: idPKNT,
      });
      console.log("Mã kết luận", response?.id);
      if (JSON.stringify(response) !== "[]") {
        setKetLuan(response);
      } else setKetLuan(null);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setKetLuan(null);
      // notification.error({message: "Lỗi khi lấy thông tin kết luận!"})
    }
  };

  const handleSave = async () => {
    try {
      const values = await concludeForm.validateFields();
      await onFinish(values);
    } catch (error) {
      const henNgayTaiKham = concludeForm.getFieldValue("ngayHenTaiKham");

      if (!henNgayTaiKham) {
        Notification("error", "Chưa chọn ngày tái khám");
      }
    }
    // concludeForm.validateFields().then(async values => {
    //   console.log(values);
    //   // ;
    // }).catch;
  };
  const removeNullIcd = dt => {
    let res = [];
    dt.map(it => {
      if (it.maIcd !== null && it.maIcd !== undefined && it.maIcd !== "") {
        res = [
          ...res,
          {
            maIcd: it.maIcd,
            tenIcd: it.tenIcd,
            ghiChu: it.ghiChu,
            mat: it?.mat,
          },
        ];
      }
    });
    return res;
  };
  const onFinish = async values => {
    if (idPKNT == null) {
      Notification("error", "Chọn phiếu khám trước khi thực hiện kết luận!");
      return;
    }
    try {
      let response;
      if (ketLuan && ketLuan.id) {
        const data = {
          ...values,
          ngayHenTaiKham: values.ngayHenTaiKham?.format("YYYY-MM-DDTHH:mm:ss"),
          chiTietKetLuans: removeNullIcd(icdSource),
          chiTietBenhPhuDtos: removeNullIcd(bpSource),
          idPhieuKhamNgoaiTru: idPKNT,
          id: ketLuan.id,
        };
        response = await medicalExaminationService.putKetLuan(data);
        setKetLuan(response);
      } else {
        const data = {
          ...values,
          ngayHenTaiKham: values.ngayHenTaiKham?.format("YYYY-MM-DDTHH:mm:ss"),
          chiTietKetLuans: removeNullIcd(icdSource),
          chiTietBenhPhuDtos: removeNullIcd(bpSource),
          idPhieuKhamNgoaiTru: idPKNT,
          idPhieuKham: dataPhieu?.idPhieuKham,
          idBenhNhan: dataPhieu?.idBenhNhan,
        };
        response = await medicalExaminationService.postKetLuan(data);
        setKetLuan(response);
      }
      Notification("success", "Lưu kết luận thành công");
    } catch (err) {
      Notification("error", err?.response?.data ?? "Lỗi khi lưu kết luận");
    }
  };
  const [count1, setCount1] = useState(1);
  const [count2, setCount2] = useState(1);
  useEffect(() => {
    fetchKetLuanByIdPKNT();
    if (idPKNT !== currentIdPKNT) {
      setIcdSource([{key: 1}]);
      // form.resetFields()
      concludeForm.resetFields();
      setBpSource([{key: 1}]);
    }
  }, [idPKNT]);
  useEffect(() => {
    if (activeExamTab == tabKeys.EXAMINATION_INFO_DETAIL.CONCLUDE_PRESCRIPT) {
      fetchKetLuanByIdPKNT();
    }
  }, [activeExamTab]);
  useEffect(() => {}, [icdList]);
  useEffect(() => {
    if (ketLuan) {
      concludeForm.setFieldsValue({
        ketLuanBacSy: ketLuan.ketLuanBacSy,
        taiKham: ketLuan.taiKham,
        ngayHenTaiKham: convertIosStringToDate(ketLuan.ngayHenTaiKham),
      });
      if (ketLuan.chiTietKetLuans.length < 1) {
        setIcdSource([{key: 1}]);
        setCount1(2);
      } else {
        setCount1(ketLuan.chiTietKetLuans.length + 1);
        setIcdSource(
          ketLuan.chiTietKetLuans.map((it, index) => {
            return {
              key: index + 1,
              maIcd: it.maIcd,
              tenIcd: it.tenIcd,
              ghiChu: it.ghiChu,
              mat: it.mat,
            };
          })
        );
      }
      if (ketLuan.chiTietBenhPhuDtos.length < 1) {
        setBpSource([{key: 1}]);
        setCount2(2);
      } else {
        setCount2(ketLuan.chiTietBenhPhuDtos.length + 1);
        setBpSource(
          ketLuan.chiTietBenhPhuDtos.map((it, index) => {
            return {
              key: index + 1,
              maIcd: it.maIcd,
              tenIcd: it.tenIcd,
              ghiChu: it.ghiChu,
            };
          })
        );
      }
    } else {
      concludeForm.resetFields();
      setCount1(2);
      setCount2(2);
      setIcdSource([{key: 1}]);
      setBpSource([{key: 1}]);
    }
  }, [ketLuan]);
  // useEffect(() => {
  //   // console.log(icdSource);
  // }, [loading, icdSource, bpSource]);
  const updateCheckBoxTaiKham = async (maBN, checked) => {
    try {
      const res = await examinationService.updateCheckboxTaiKham(maBN, checked);
      dispatch(setDataPhieu(res));
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi không cập nhật được giá trị theo dõi bệnh nhân mãn tính"
      );
      form.setFieldValue("theoDoi", theoDoi);
    }
  };
  useEffect(() => {
    form.setFieldValue("theoDoi", dataPhieu?.checkBox);
  }, [dataPhieu]);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [isShowModalPrintXNM, setIsShowModalPrintXNM] = useState(false);
  const [isShowModalPrintTTT, setIsShowModalPrintTTT] = useState(false);
  const handleOnPrint = () => {
    if (!icdSource.find(obj => obj.maIcd)?.maIcd) {
      Notification("warning", "Vui lòng chọn đầy đủ thông tin kết luận(ICD)");
      return;
    }
    setIsShowModalPrint(true);
  };
  const handleOpen = () => {
    setIsShowModalPrint(false);
  };
  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };
  const handleOnPrintXNM = () => {
    if (!icdSource.find(obj => obj.maIcd)?.maIcd) {
      Notification("warning", "Vui lòng chọn đầy đủ thông tin kết luận(ICD)");
      return;
    }
    setIsShowModalPrintXNM(true);
  };
  const handleOpenXNM = () => {
    setIsShowModalPrintXNM(false);
  };
  const handleCancelPrintXNM = () => {
    setIsShowModalPrintXNM(false);
  };
  const handleOnPrintTTT = () => {
    if (!icdSource.find(obj => obj.maIcd)?.maIcd) {
      Notification("warning", "Vui lòng chọn đầy đủ thông tin kết luận(ICD)");
      return;
    }
    setIsShowModalPrintTTT(true);
  };
  const handleOpenTTT = () => {
    setIsShowModalPrintTTT(false);
  };
  const handleCancelPrintTTT = () => {
    setIsShowModalPrintTTT(false);
  };
  return (
    <Spin spinning={loading}>
      <div className="conclude-icd">
        <Space direction="vertical" className="prescription-space">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Typography className="prescription-table-title">
                Kết luận (ICD)
              </Typography>
            </Col>
            <Col>
              <Space>
                <Button
                  type="primary"
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={handleOnPrintTTT}
                >
                  In phiếu yêu cầu XN phẫu thuật đục TTT
                </Button>
                <Button
                  type="primary"
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={handleOnPrintXNM}
                >
                  In phiếu yêu cầu XN phẫu thuật mộng
                </Button>
                <Button
                  type="primary"
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={handleOnPrint}
                >
                  In phiếu yêu cầu XN trung phẫu
                </Button>
              </Space>
            </Col>
            {/* <Col>
              <Form form={concludeForm} onFinish={onFinish}>
                <Form.Item>
                  <Button
                    type="primary"
                    icon={<Icons.save rev={0} />}
                    htmlType="submit"
                    onClick={handleSave}
                  >
                    Lưu lại
                  </Button>
                </Form.Item>
              </Form>
            </Col> */}
          </Row>
          <TableInputAdd
            loading={loading}
            column={columnsIcd}
            data={icdSource}
            setData={setIcdSource}
            pagination={false}
            icdList={icdList}
            count1={count1}
            setCount1={setCount1}
          />
          <Row justify={"end"}>
            <Form form={form}>
              <Form.Item
                name="theoDoi"
                valuePropName="checked"
                label="Theo dõi bệnh nhân mãn tính"
              >
                <Checkbox
                  onChange={e => {
                    updateCheckBoxTaiKham(
                      dataPhieu?.maBenhNhan,
                      e?.target?.checked
                    );
                  }}
                />
              </Form.Item>
            </Form>
          </Row>
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Typography className="prescription-table-title">
                Bệnh phụ
              </Typography>
            </Col>
          </Row>
          <TableInputAdd2
            loading={loading}
            column={columnsBp}
            data={bpSource}
            setData={setBpSource}
            pagination={false}
            icdList={icdList}
            count2={count2}
            setCount2={setCount2}
          />
          <Form form={concludeForm}>
            <Row gutter={[0, 8]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Chẩn đoán khác</Typography.Text>
                  }
                  name="ketLuanBacSy"
                  labelAlign="left"
                  labelCol={{span: 4}}
                  wrapperCol={{span: 20}}
                >
                  <Input className="data-input-field" placeholder="Nhập" />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  label={<Typography.Text ellipsis>Hẹn tái khám</Typography.Text>}
                  name="taiKham"
                  labelAlign="left"
                  labelCol={{span: 4}}
                  wrapperCol={{span: 20}}
                >
                  <Input 
                    className="data-input-field"
                    placeholder="Nhập"
                  />
                </Form.Item>
              </Col> */}
            </Row>
          </Form>
        </Space>
        <ModalPrintTP
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          listICDTP={icdSource}
          dataTable={dataPhieu}
        />
        <ModalPrintXNM
          isShowModalM={isShowModalPrintXNM}
          handleOk={handleOpenXNM}
          handleCancel={handleCancelPrintXNM}
          listICDXNM={icdSource}
          dataTable={dataPhieu}
        />
        <ModalPrintTTT
          isShowModalT={isShowModalPrintTTT}
          handleOk={handleOpenTTT}
          handleCancel={handleCancelPrintTTT}
          listICDTTT={icdSource}
          dataTable={dataPhieu}
        />
      </div>
    </Spin>
  );
});

export default ConcludeIcd;
